"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.collectFees = exports.redeem = exports.cancelOrder = exports.settleFunds = exports.createOrder = exports.deposit = exports.createPool = exports.PUBLIC_POOLS_SEEDS = exports.FIDA_KEY = exports.SERUM_PROGRAM_ID = exports.BONFIDA_BNB_KEY = exports.BONFIDA_FEE_KEY = exports.BONFIDABOT_PROGRAM_ID = exports.ENDPOINTS = void 0;
const web3_js_1 = require("@solana/web3.js");
const spl_token_1 = require("@solana/spl-token");
const instructions_1 = require("./instructions");
const utils_1 = require("./utils");
const state_1 = require("./state");
const bs58_1 = __importDefault(require("bs58"));
const crypto = __importStar(require("crypto"));
const awesome_serum_markets_1 = require("@dr497/awesome-serum-markets");
const serum_1 = require("@project-serum/serum");
/////////////////////////////////
exports.ENDPOINTS = {
    mainnet: 'https://solana-api.projectserum.com',
    devnet: 'https://devnet.solana.com',
    mainnet2: 'https://api.mainnet-beta.solana.com'
};
exports.BONFIDABOT_PROGRAM_ID = new web3_js_1.PublicKey('63xyXHpA6EVF69kRmEbXAr8aBEkhgpaNUSRoTQyi5Rwr');
exports.BONFIDA_FEE_KEY = new web3_js_1.PublicKey('31LVSggbVz4VcwBSPdtK8HJ3Lt1cKTJUVQTRNNYMfqBq');
exports.BONFIDA_BNB_KEY = new web3_js_1.PublicKey('3oQzjfjzUkJ5qHsERk2JPEpAKo34dxAQjUriBqursfxU');
exports.SERUM_PROGRAM_ID = new web3_js_1.PublicKey('9xQeWvG816bUx9EPjHmaT23yvVM2ZWbrrpZb9PusVFin');
exports.FIDA_KEY = new web3_js_1.PublicKey('EchesyfXePKdLtoiZSL8pBe8Myagyy8ZRqsACNCFGnvp');
exports.PUBLIC_POOLS_SEEDS = [
    new web3_js_1.PublicKey('HFhJ3k84H3K3iCNHbkTZ657r9fwQGux7czUZavhm4ebV'),
];
/////////////////////////////////
/**
 * Returns the solana instructions to create a new pool by performing the first deposit of any number of different tokens
 * and setting the pubkey of the signal provider. The first deposit will fix the initial
 * value of 1 pooltoken (credited to the target) with respect to the deposited tokens.
 * (Signed by the sourceOwner account)
 *
 * @param connection The connection object to the rpc node
 * @param sourceOwnerKey The address of the wallet that owns the tokens to be invested in the pool
 * @param sourceAssetKeys The adresses of the token accounts that hold the tokens to be invested in the pool
 * @param signalProviderKey The key of the account that will have the right to trade with the funds of the pool
 * @param depositAmounts An array of the amounts that should be invested for each token, in the same order as the sourceAssetKeys
 * @param maxNumberOfAssets The maximum number of different tokens the pool will ever be able to hold (solana memory allocation is fixed)
 * @param markets An array of the addresses of the serum markets that the signalProvider will be able to trade on
 * @param payer The address of the account that should pay for the allocation fees
 * @param feeCollectionPeriod The smallest period in seconds after which the trading fees can be payed out again (minimum is 604800 s or 1 week)
 * @param feePercentage The percentage (a number from 0 to 100) of the pool assets that should be collected as fees
 */
async function createPool(connection, sourceOwnerKey, sourceAssetKeys, signalProviderKey, depositAmounts, maxNumberOfAssets, markets, payer, feeCollectionPeriod, feePercentage) {
    // Find a valid pool seed
    let poolSeed;
    let poolKey;
    let bump;
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    while (true) {
        poolSeed = crypto.randomBytes(32);
        [poolKey, bump] = await web3_js_1.PublicKey.findProgramAddress([poolSeed.slice(0, 31)], exports.BONFIDABOT_PROGRAM_ID);
        poolSeed[31] = bump;
        try {
            await web3_js_1.PublicKey.createProgramAddress([poolSeed, array_one], exports.BONFIDABOT_PROGRAM_ID);
            break;
        }
        catch (e) {
            continue;
        }
    }
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed, array_one], exports.BONFIDABOT_PROGRAM_ID);
    console.log('Pool seed: ', bs58_1.default.encode(poolSeed));
    console.log('Pool key: ', poolKey.toString());
    console.log('Mint key: ', poolMintKey.toString());
    // Initialize the pool
    // @ts-ignore
    let numberOfMarkets = new utils_1.Numberu16(markets.length);
    let initTxInstruction = instructions_1.initInstruction(spl_token_1.TOKEN_PROGRAM_ID, web3_js_1.SystemProgram.programId, web3_js_1.SYSVAR_RENT_PUBKEY, exports.BONFIDABOT_PROGRAM_ID, poolMintKey, payer, poolKey, [poolSeed], maxNumberOfAssets, numberOfMarkets);
    // Create the pool asset accounts
    let poolAssetKeys = new Array();
    let assetTxInstructions = new Array();
    for (let sourceAssetKey of sourceAssetKeys) {
        let assetInfo = await connection.getAccountInfo(sourceAssetKey);
        if (!assetInfo) {
            throw 'Source asset account is unavailable';
        }
        let assetData = Buffer.from(assetInfo.data);
        const assetMint = new web3_js_1.PublicKey(spl_token_1.AccountLayout.decode(assetData).mint);
        assetTxInstructions.push(await utils_1.createAssociatedTokenAccount(web3_js_1.SystemProgram.programId, payer, poolKey, assetMint));
        poolAssetKeys.push(await utils_1.findAssociatedTokenAddress(poolKey, assetMint));
    }
    // If nonexistent, create the source owner associated addresses to receive the pooltokens
    let txInstructions = [initTxInstruction];
    let [targetPoolTokenKey, targetPTInstruction] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, sourceOwnerKey, poolMintKey, payer);
    targetPTInstruction ? txInstructions.push(targetPTInstruction) : null;
    // Verify that the markets are authorized
    console.log(markets.length);
    for (let i = 0; i < markets.length; i++) {
        let marketAddress = markets[i];
        let marketIndex = serum_1.MARKETS.map(m => {
            return m.address.toString();
        }).lastIndexOf(marketAddress.toString());
        let awsomeMarketIndex = awesome_serum_markets_1.AWESOME_MARKETS.map(m => {
            return m.address.toString();
        }).lastIndexOf(marketAddress.toString());
        if ((marketIndex == -1) && (awsomeMarketIndex == -1)) {
            throw "Market is not authorized";
        }
        let market = (marketIndex != -1) ? serum_1.MARKETS[marketIndex] : awesome_serum_markets_1.AWESOME_MARKETS[awsomeMarketIndex];
        if (market.deprecated) {
            throw "Given market is deprecated";
        }
    }
    // Create the pool
    // @ts-ignore
    let feeRatioU16 = new utils_1.Numberu16(2 ** 16 * feePercentage / 100);
    let createTxInstruction = instructions_1.createInstruction(spl_token_1.TOKEN_PROGRAM_ID, exports.BONFIDABOT_PROGRAM_ID, web3_js_1.SYSVAR_CLOCK_PUBKEY, poolMintKey, poolKey, [poolSeed], poolAssetKeys, targetPoolTokenKey, sourceOwnerKey, sourceAssetKeys, exports.SERUM_PROGRAM_ID, signalProviderKey, depositAmounts, markets, feeCollectionPeriod, feeRatioU16);
    txInstructions = txInstructions.concat(assetTxInstructions);
    txInstructions.push(createTxInstruction);
    return [poolSeed, txInstructions];
}
exports.createPool = createPool;
/**
 * Returns the solana instructions to buy into the pool. The source deposits tokens into the pool and the target receives
 * a corresponding amount of pool-token in exchange. The program will try to
 * maximize the deposit sum with regards to the amounts given by the source and
 * the ratio of tokens present in the pool at that moment. Tokens can only be deposited
 * in the exact ratio of tokens that are present in the pool.
 * (Signed by the sourceOwnerKey)
 *
 * @param connection The connection object to the rpc node
 * @param sourceOwnerKey The address of the wallet that owns the tokens to be invested in the pool
 * @param sourceAssetKeys The adresses of the token accounts that hold the tokens to be invested in the pool
 * @param poolTokenAmount The amount of pooltokens that should be bought (ie the amount of tokens that should be invested)
 * @param poolSeed The seed of the pool that should be invested into
 * @param payer The address of the account that should pay for the allocation fees
 */
async function deposit(connection, sourceOwnerKey, sourceAssetKeys, poolTokenAmount, poolSeed, payer) {
    // Find the pool key and mint key
    let poolKey = await web3_js_1.PublicKey.createProgramAddress(poolSeed, exports.BONFIDABOT_PROGRAM_ID);
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress(poolSeed.concat(array_one), exports.BONFIDABOT_PROGRAM_ID);
    let poolInfo = await connection.getAccountInfo(poolKey);
    if (!poolInfo) {
        throw 'Pool account is unavailable';
    }
    let poolData = poolInfo.data;
    let poolHeader = state_1.PoolHeader.fromBuffer(poolData.slice(0, state_1.PoolHeader.LEN));
    let poolAssets = state_1.unpack_assets(poolData.slice(state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH));
    let poolAssetKeys = [];
    for (var asset of poolAssets) {
        let assetKey = await utils_1.findAssociatedTokenAddress(poolKey, asset.mintAddress);
        poolAssetKeys.push(assetKey);
    }
    // If nonexistent, create the source owner and signal provider associated addresses to receive the pooltokens
    let createTargetsTxInstructions = [];
    let [targetPoolTokenKey, targetPTInstruction] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, sourceOwnerKey, poolMintKey, payer);
    targetPTInstruction ? createTargetsTxInstructions.push(targetPTInstruction) : null;
    let [sigProviderFeeReceiverKey, sigProvInstruction] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, poolHeader.signalProvider, poolMintKey, payer);
    sigProvInstruction ? createTargetsTxInstructions.push(sigProvInstruction) : null;
    let [bonfidaFeeReceiverKey, bonfidaFeeInstruction] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, exports.BONFIDA_FEE_KEY, poolMintKey, payer);
    bonfidaFeeInstruction ? createTargetsTxInstructions.push(bonfidaFeeInstruction) : null;
    let [bonfidaBuyAndBurnKey, bonfidaBNBInstruction] = await utils_1.findAndCreateAssociatedAccount(web3_js_1.SystemProgram.programId, connection, exports.BONFIDA_BNB_KEY, poolMintKey, payer);
    bonfidaBNBInstruction ? createTargetsTxInstructions.push(bonfidaBNBInstruction) : null;
    let depositTxInstruction = instructions_1.depositInstruction(spl_token_1.TOKEN_PROGRAM_ID, exports.BONFIDABOT_PROGRAM_ID, sigProviderFeeReceiverKey, bonfidaFeeReceiverKey, bonfidaBuyAndBurnKey, poolMintKey, poolKey, poolAssetKeys, targetPoolTokenKey, sourceOwnerKey, sourceAssetKeys, poolSeed, poolTokenAmount);
    return createTargetsTxInstructions.concat(depositTxInstruction);
}
exports.deposit = deposit;
/**
 * Returns the solana instructions to create a new serum order for the pool.
 * (Signed by the SignalProvider account of the pool and the OpenOrder Account
 * returned by this function)
 *
 * @param connection The connection object to the rpc node
 * @param poolSeed The seed of the pool that should be traded on
 * @param market The address of the serum market to trade on
 * @param side The side of the order (ask or bid)
 * @param limitPrice The limit price for the order
 * @param maxQuantityPercentage The percentage (a number from 0 to 100) of the pool assets that should be invested
 * @param orderType For now, all orders are to be set as type ImmediateOrCancel
 * @param clientId The serum clientId for the order, can be set as 0
 * @param selfTradeBehavior The serum self trade behaviour for the order
 * @param srmDiscountKey The address of the srm discount key for the order (optional)
 * @param payerKey The address of the account that should pay for the allocation fees
 * @param amountToTrade If this optional argument is given, it will overwrite the maxQuantityPercentage and fix
 *  the size of the order in base quantity. If you want to trade one and a half FIDA on FIDA/USDC for example,
 *  give 1.5 as an input here.
 */
async function createOrder(connection, poolSeed, market, side, limitPrice, maxQuantityPercentage, orderType, clientId, selfTradeBehavior, srmDiscountKey, payerKey, amountToTrade) {
    // Find the pool key
    let poolKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed], exports.BONFIDABOT_PROGRAM_ID);
    let poolInfo = await connection.getAccountInfo(poolKey);
    if (!poolInfo) {
        throw 'Pool account is unavailable';
    }
    let poolHeader = state_1.PoolHeader.fromBuffer(poolInfo.data.slice(0, state_1.PoolHeader.LEN));
    let marketData = await utils_1.getMarketData(connection, market);
    let sourceMintKey;
    let targetMintKey;
    if (side == state_1.OrderSide.Ask) {
        sourceMintKey = marketData.coinMintKey;
        targetMintKey = marketData.pcMintKey;
    }
    else {
        sourceMintKey = marketData.pcMintKey;
        targetMintKey = marketData.coinMintKey;
    }
    console.log('Market key: ', market.toString());
    let authorizedMarkets = state_1.unpack_markets(poolInfo.data.slice(state_1.PoolHeader.LEN, state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH), poolHeader.numberOfMarkets);
    let marketIndex = authorizedMarkets
        .map(m => {
        return m.toString();
    })
        .indexOf(market.toString());
    let poolAssets = state_1.unpack_assets(poolInfo.data.slice(state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH));
    let sourcePoolAssetIndex = new utils_1.Numberu64(
    // @ts-ignore
    poolAssets
        .map(a => {
        return a.mintAddress.toString();
    })
        .indexOf(sourceMintKey.toString()));
    let sourcePoolAssetKey = await utils_1.findAssociatedTokenAddress(poolKey, sourceMintKey);
    // @ts-ignore
    let targetPoolAssetIndex = poolAssets
        .map(a => {
        return a.mintAddress.toString();
    })
        .indexOf(targetMintKey.toString());
    let createTargetAssetInstruction = undefined;
    if (targetPoolAssetIndex == -1) {
        // Create the target asset account if nonexistent
        let createTargetAssetInstruction = await utils_1.createAssociatedTokenAccount(web3_js_1.SystemProgram.programId, payerKey, poolKey, targetMintKey);
        targetPoolAssetIndex = poolAssets.length;
    }
    // Create the open order account with trhe serum specific size of 3228 bits
    let rent = await connection.getMinimumBalanceForRentExemption(3228);
    let openOrderAccount = new web3_js_1.Account();
    let openOrderKey = openOrderAccount.publicKey;
    let createAccountParams = {
        fromPubkey: payerKey,
        newAccountPubkey: openOrderKey,
        lamports: rent,
        space: 3228,
        programId: exports.SERUM_PROGRAM_ID,
    };
    let createOpenOrderAccountInstruction = web3_js_1.SystemProgram.createAccount(createAccountParams);
    console.log('Open Order key: ', openOrderKey.toString());
    // Calcutlate the amount to trade as a ratio fo the pool balance
    let sourcePoolAssetBalance = (await connection.getTokenAccountBalance(sourcePoolAssetKey)).value;
    // @ts-ignore
    let maxQuantityRatioU16 = (!amountToTrade) ? new utils_1.Numberu16(2 ** 16 * maxQuantityPercentage / 100)
        // @ts-ignore
        : new utils_1.Numberu16((2 ** 16 * amountToTrade / (sourcePoolAssetBalance['uiAmount'])));
    let createOrderTxInstruction = instructions_1.createOrderInstruction(exports.BONFIDABOT_PROGRAM_ID, poolHeader.signalProvider, market, sourcePoolAssetKey, sourcePoolAssetIndex, 
    // @ts-ignore
    new utils_1.Numberu64(targetPoolAssetIndex), openOrderKey, marketData.reqQueueKey, marketData.eventQueueKey, marketData.bidsKey, marketData.asksKey, poolKey, marketData.coinVaultKey, marketData.pcVaultKey, spl_token_1.TOKEN_PROGRAM_ID, exports.SERUM_PROGRAM_ID, web3_js_1.SYSVAR_RENT_PUBKEY, srmDiscountKey, [poolSeed], side, limitPrice, 
    // @ts-ignore
    new utils_1.Numberu16(marketIndex), marketData.coinLotSize, marketData.pcLotSize, targetMintKey, maxQuantityRatioU16, orderType, clientId, selfTradeBehavior, 
    // @ts-ignore
    new utils_1.Numberu16((1 << 16) - 1));
    let instructions = [
        createOpenOrderAccountInstruction,
        createOrderTxInstruction,
    ];
    if (!!createTargetAssetInstruction) {
        instructions.unshift(createTargetAssetInstruction);
    }
    return [openOrderAccount, instructions];
}
exports.createOrder = createOrder;
/**
 * Returns the solana instructions to a crank to settle funds out of one of the pool's active OpenOrders accounts.
 * (Permissionless)
 *
 * @param connection The connection object to the rpc node
 * @param poolSeed The seed of the pool that should be settled
 * @param market The address of the serum market on which the order is
 * @param openOrdersKey The address of the serum openOrder account to settle
 * @param srmReferrerKey The address of the referer that should receive the serum trading fees
 */
async function settleFunds(connection, poolSeed, market, openOrdersKey, srmReferrerKey) {
    let poolKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed], exports.BONFIDABOT_PROGRAM_ID);
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed, array_one], exports.BONFIDABOT_PROGRAM_ID);
    let poolInfo = await connection.getAccountInfo(poolKey);
    if (!poolInfo) {
        throw 'Pool account is unavailable';
    }
    let marketData = await utils_1.getMarketData(connection, market);
    let poolHeader = state_1.PoolHeader.fromBuffer(poolInfo.data.slice(0, state_1.PoolHeader.LEN));
    let poolAssets = state_1.unpack_assets(poolInfo.data.slice(state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH));
    let coinPoolAssetIndex = new utils_1.Numberu64(
    // @ts-ignore
    poolAssets
        .map(a => {
        return a.mintAddress.toString();
    })
        .indexOf(marketData.coinMintKey.toString()));
    let coinPoolAssetKey = await utils_1.findAssociatedTokenAddress(poolKey, marketData.coinMintKey);
    let pcPoolAssetIndex = new utils_1.Numberu64(
    // @ts-ignore
    poolAssets
        .map(a => {
        return a.mintAddress.toString();
    })
        .indexOf(marketData.pcMintKey.toString()));
    let pcPoolAssetKey = await utils_1.findAssociatedTokenAddress(poolKey, marketData.pcMintKey);
    let vaultSignerKey = await web3_js_1.PublicKey.createProgramAddress([market.toBuffer(), marketData.vaultSignerNonce.toBuffer()], exports.SERUM_PROGRAM_ID);
    let settleFundsTxInstruction = instructions_1.settleFundsInstruction(exports.BONFIDABOT_PROGRAM_ID, market, openOrdersKey, poolKey, poolMintKey, marketData.coinVaultKey, marketData.pcVaultKey, coinPoolAssetKey, pcPoolAssetKey, vaultSignerKey, spl_token_1.TOKEN_PROGRAM_ID, exports.SERUM_PROGRAM_ID, srmReferrerKey, [poolSeed], pcPoolAssetIndex, coinPoolAssetIndex);
    return [settleFundsTxInstruction];
}
exports.settleFunds = settleFunds;
/**
 * This method is obsolete for now as all orders can only be passed as ImmediateOrCancel
 *
 * @param connection
 * @param poolSeed
 * @param market
 * @param openOrdersKey
 */
async function cancelOrder(connection, poolSeed, market, openOrdersKey) {
    // Find the pool key
    let poolKey = await web3_js_1.PublicKey.createProgramAddress([poolSeed], exports.BONFIDABOT_PROGRAM_ID);
    let poolInfo = await connection.getAccountInfo(poolKey);
    if (!poolInfo) {
        throw 'Pool account is unavailable';
    }
    let signalProviderKey = state_1.PoolHeader.fromBuffer(poolInfo.data.slice(0, state_1.PoolHeader.LEN)).signalProvider;
    let marketData = await utils_1.getMarketData(connection, market);
    let openOrders = await serum_1.OpenOrders.load(connection, openOrdersKey, exports.SERUM_PROGRAM_ID);
    let orders = openOrders.orders;
    // @ts-ignore
    let orderId = new utils_1.Numberu128(orders[0].toBuffer());
    // @ts-ignore
    if (orderId == new utils_1.Numberu128(0)) {
        throw 'No orders found in Openorder account.';
    }
    let side = 1 - orderId.toBuffer()[7];
    let cancelOrderTxInstruction = await instructions_1.cancelOrderInstruction(exports.BONFIDABOT_PROGRAM_ID, signalProviderKey, market, openOrdersKey, marketData.eventQueueKey, marketData.bidsKey, marketData.asksKey, poolKey, exports.SERUM_PROGRAM_ID, [poolSeed], side, orderId);
    return [cancelOrderTxInstruction];
}
exports.cancelOrder = cancelOrder;
/**
 * Returns the solana instructions to buy out of the pool by redeeming (burning) pooltokens.
 * This instruction needs to be executed after (and within the same transaction)
 * having settled on all possible open orders for the pool.
 * This is because as long as an order is open for the pool, redeeming is impossible.
 * (Signed by the owner of the pooltokens)
 *
 * @param connection The connection object to the rpc node
 * @param sourcePoolTokenOwnerKey The address of the account that owns the pooltokens to be redeemed
 * @param sourcePoolTokenKey The address that holds the pooltokens
 * @param targetAssetKeys An array of addresses to which the pool asset tokens are payed out to
 * @param poolSeed The seed of the pool that should be redeemed from
 * @param poolTokenAmount The amount of pooltokens that should be used (ie the amount of tokens that should be bought back)
 */
async function redeem(connection, sourcePoolTokenOwnerKey, sourcePoolTokenKey, targetAssetKeys, poolSeed, poolTokenAmount) {
    // Find the pool key and mint key
    let poolKey = await web3_js_1.PublicKey.createProgramAddress(poolSeed, exports.BONFIDABOT_PROGRAM_ID);
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress(poolSeed.concat(array_one), exports.BONFIDABOT_PROGRAM_ID);
    let poolInfo = await connection.getAccountInfo(poolKey);
    if (!poolInfo) {
        throw 'Pool account is unavailable';
    }
    let poolData = poolInfo.data;
    let poolHeader = state_1.PoolHeader.fromBuffer(poolData.slice(0, state_1.PoolHeader.LEN));
    let poolAssets = state_1.unpack_assets(poolInfo.data.slice(state_1.PoolHeader.LEN + Number(poolHeader.numberOfMarkets) * state_1.PUBKEY_LENGTH));
    let poolAssetKeys = [];
    for (var asset of poolAssets) {
        let assetKey = await utils_1.findAssociatedTokenAddress(poolKey, asset.mintAddress);
        poolAssetKeys.push(assetKey);
    }
    let redeemTxInstruction = instructions_1.redeemInstruction(spl_token_1.TOKEN_PROGRAM_ID, exports.BONFIDABOT_PROGRAM_ID, web3_js_1.SYSVAR_CLOCK_PUBKEY, poolMintKey, poolKey, poolAssetKeys, sourcePoolTokenOwnerKey, sourcePoolTokenKey, targetAssetKeys, poolSeed, poolTokenAmount);
    return [redeemTxInstruction];
}
exports.redeem = redeem;
/**
 *  Returns the solana instructions to collect the fees from the pool.
 *  See the readme for the payout destinations.
 * (Permissionless)
 *
 * @param connection The connection object to the rpc node
 * @param poolSeed The seed of the pool
 */
async function collectFees(connection, poolSeed) {
    // Find the pool key and mint key
    let poolKey = await web3_js_1.PublicKey.createProgramAddress(poolSeed, exports.BONFIDABOT_PROGRAM_ID);
    let array_one = new Uint8Array(1);
    array_one[0] = 1;
    let poolMintKey = await web3_js_1.PublicKey.createProgramAddress(poolSeed.concat(array_one), exports.BONFIDABOT_PROGRAM_ID);
    let poolInfo = await connection.getAccountInfo(poolKey);
    if (!poolInfo) {
        throw 'Pool account is unavailable';
    }
    let poolData = poolInfo.data;
    let poolHeader = state_1.PoolHeader.fromBuffer(poolData.slice(0, state_1.PoolHeader.LEN));
    let sigProviderFeeReceiverKey = await utils_1.findAssociatedTokenAddress(poolHeader.signalProvider, poolMintKey);
    let bonfidaFeeReceiverKey = await utils_1.findAssociatedTokenAddress(exports.BONFIDA_FEE_KEY, poolMintKey);
    let bonfidaBuyAndBurnKey = await utils_1.findAssociatedTokenAddress(exports.BONFIDA_BNB_KEY, poolMintKey);
    let collectFeesTxInstruction = instructions_1.collectFeesInstruction(spl_token_1.TOKEN_PROGRAM_ID, web3_js_1.SYSVAR_CLOCK_PUBKEY, exports.BONFIDABOT_PROGRAM_ID, poolKey, poolMintKey, sigProviderFeeReceiverKey, bonfidaFeeReceiverKey, bonfidaBuyAndBurnKey, poolSeed);
    return [collectFeesTxInstruction];
}
exports.collectFees = collectFees;
//# sourceMappingURL=main.js.map